import { OrganizationType } from 'types/publishedAssets';
import { QbSurveyInfo } from 'types/qbSurveyInfo';
import { SurveyType } from 'types/survey';

interface props {
  organization?: OrganizationType;
  survey?: SurveyType;
  questionnaire?: QbSurveyInfo;
}

export const determineCountryFromProps = (pageProps: props) =>
  pageProps?.organization?.country || pageProps?.survey?.client?.country || pageProps?.questionnaire?.client?.country;

export const determineRegionFromProps = (region?: string) => {
  switch (region) {
    case 'CA':
      return 'CA';
    case 'GB':
      return 'EU';
    case 'US':
    default:
      return 'US';
  }
};
